const organisation = {
  add_a_tax: 'Add a tax',
  account_type: 'Account Country',
  name_en: 'English Name',
  name_fr: 'French Name',
  legal_name: 'Legal Name',
  is_npo: 'Non profit organisation',
  is_jewish: 'Jewish',
  filter: 'Filter',
  email: 'Email',
  address: 'Address',
  city: 'City',
  suite: 'Suite',
  state: 'State',
  zipCode: 'Zip Code',
  phone: 'Phone',
  extension: 'Extension',
  organisation_type: 'Organisation Types',
  registration_number: 'Registration Number',
  tollfreePhone: 'Toll free phone',
  tollfreeExtension: 'Toll free extention',
  upload_tax_receipt_background: 'Upload tax receipt background',
  tax_receipt_background: 'Tax receipt background',
  timezone: 'Timezone',
  upload_logo: 'Upload logo',
  upload_signature: 'Upload signature',
  validation_errors: 'Validation error(s). Please review your data.',
  user_validation_errors: 'Validation error(s). Please review your data.',
  website: 'Website',
  receipt_email_title: 'Receipt email title',
  receipt_email_message: 'Receipt email message',
  invoice_email_title: 'Invoice email title',
  invoice_email_message: 'Invoice email message',
  email_tags_help: 'Please use the following tags in your emails:',
  email_tags_auto_replace: 'The system will automatically replace them.',
  tag_first_name: '#first-name : First name displayed in the Receipt or Invoice',
  tag_last_name: '#last-name : Last name displayed in the Receipt or Invoice',
  tag_company_name: '#company-name : Company name displayed in the Receipt or Invoice',
  tag_amount: '#amount : Amount displayed in the Receipt or Invoice',
  tag_receipt_nb: '#receipt-nb : Receipt number of the receipt',
  tag_invoice_nb: '#invoice-nb : Invoice number of the invoice',
};

export default organisation;
